import { useEffect, useRef } from 'react';

import Image from 'next/image';

import { heycarLoader } from '@core/Components/HeycarImage/HeycarLoader';
import { Image360 } from '@shared-components/Image360/Image360';
import VideoIframe from '@shared-components/VideoIframe/VideoIframe';

import { VIDEO_TAB_NAME, IMAGES_TAB_NAME, IMAGES_360_TAB_NAME } from '../Gallery.constants';
import { PatchworkGalleryProps } from '../Gallery.entity';

import { GalleryTabs } from '../GalleryTabs';

import styles from './PatchworkGallery.module.css';

const PatchworkGallery = ({
  images,
  handleImageClick,
  currentIndex,
  video,
  activeTab,
  setActiveTab,
  hasVideo,
  has360Images,
  images360,
  tabStrings,
  galleryStrings,
}: PatchworkGalleryProps) => {
  const currentImageRef = useRef<HTMLLIElement>(null);

  const handleKeyDown = (index: number) => (event: React.KeyboardEvent<HTMLLIElement>) => {
    if (event.key === 'Enter') {
      handleImageClick(index);
    }
  };

  useEffect(() => {
    document.body.classList.add('lockScroll');
    currentImageRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
    return () => {
      document.body.classList.remove('lockScroll');
    };
  }, []);

  return (
    <>
      {activeTab === VIDEO_TAB_NAME && (
        <div className={styles.videoWrapper}>
          <VideoIframe title="Vehicle video" video={video} />
        </div>
      )}
      {activeTab === IMAGES_360_TAB_NAME && images360 && (
        <Image360 images={images360} galleryStrings={galleryStrings} />
      )}

      {activeTab === IMAGES_TAB_NAME && (
        <ul className={styles.imageWrapper} data-test-id="patchwork-gallery">
          {images.map((image, index) => {
            let refProp = {};
            if (index === currentIndex) {
              refProp = { ref: currentImageRef };
            }

            return (
              <li
                key={image.url}
                tabIndex={0}
                onClick={() => handleImageClick(index)}
                onKeyDown={handleKeyDown(index)}
                aria-label={`images-of-${index}`}
                {...refProp}
              >
                <Image
                  src={image.url}
                  className={styles.image}
                  alt={image.altText || ''}
                  width={400}
                  height={400}
                  loader={heycarLoader}
                />
              </li>
            );
          })}
        </ul>
      )}
      <GalleryTabs
        activeTab={activeTab}
        switchTab={setActiveTab}
        strings={tabStrings}
        hasVideo={hasVideo}
        has360Images={has360Images}
      />
    </>
  );
};

export default PatchworkGallery;
